<template>
  <div class="footer">
    <div
      class="button"
      @click="selectMenu(5)"
      :class="index == 5 ? 'button-active' : ''"
    >
      <img src="@/assets/images/companyinfo.png" alt="" v-if="index != 5" />
      <img
        src="@/assets/images/companyinfo-active.png"
        alt=""
        v-if="index == 5"
      />
      <div>产出物库存</div>
    </div>
    <el-popover
      placement="top"
      width="200"
      trigger="click"
      v-model="showPopover"
    >
      <div class="button-footer">
        <div class="button" @click="selectMenu(6)">
          <img src="@/assets/images/companyinfo.png" alt="" />

          <div>过 道</div>
        </div>
        <div class="button" @click="selectMenu(7)">
          <img src="@/assets/images/companyinfo.png" alt="" />
          <div>库存区</div>
        </div>
        <div class="button" @click="selectMenu(8)">
          <img src="@/assets/images/companyinfo.png" alt="" />
          <div>拆解区</div>
        </div>
      </div>

      <div
        class="button"
        slot="reference"
        :class="index == 6 || index == 7 || index == 8 ? 'button-active' : ''"
      >
        <img
          src="@/assets/images/companyinfo-active.png"
          alt=""
          v-if="index == 6 || index == 7 || index == 8"
        />
        <img src="@/assets/images/companyinfo.png" alt="" v-else />

        <div>监控分组</div>
      </div>
    </el-popover>
  </div>
</template>
  
  <script>
export default {
  props: ["index"],
  data() {
    return {
      showPopover: false,
      nowTime: "",
      type: "index",
    };
  },

  methods: {
    selectMenu(index) {
      this.showPopover = false;
      this.$emit("selectMenu", index);
    },
  },
};
</script>
  <style>
.button-footer .button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("~@/assets/botton.png") no-repeat center;
  background-size: 100% 100%;
  width: 200px;
  padding: 10px 0;
  color: #fff;
  /*  */
  cursor: pointer;
}
.button-footer .button img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
.el-popover {
  background: unset;
  padding: unset;
  border: unset;
  border-radius: unset;
}
</style>
